import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const deactivateModuleApi = createApi({
    reducerPath: "deactivateModuleApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    tagTypes: ["getDeactivateModule", "getDeactivateModuleById", "createDeactivateModule", "updateDeactivateModule"],
    endpoints: (builder) => ({
        getDeactivateModule: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getDeactivateModule"],
            method: "GET"
        }),
        getDeactivateModuleById: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getDeactivateModuleById"],
        }),

        createDeactivateModule: builder.mutation({
            query: ({ endpoint, data }) => {
                return {
                    url: endpoint,
                    method: "POST",
                    body: data,
                };
            },
            invalidatesTags: ["createDeactivateModule"],
        }),

        updateDeactivateModule: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updateDeactivateModule"],
        }),
         updateDeactivateModuleStatus: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updateDeactivateModuleStatus"],
        }),
        deleteDeactivateModule: builder.mutation({
            query: ({ endpoint }) => {
                return {
                    url: endpoint,
                    method: "DELETE",
                   
                };
            },
            invalidatesTags: ["updateDeactivateModuleStatus"],
        }),
    }),
});

export const {
    useCreateDeactivateModuleMutation,
    useGetDeactivateModuleQuery,
    useGetDeactivateModuleByIdQuery,
    useUpdateDeactivateModuleMutation,
    useUpdateDeactivateModuleStatusMutation,
    useDeleteDeactivateModuleMutation
} = deactivateModuleApi;
